import { useMutation } from '@tanstack/react-query';

import { getSMPBackendAPIAdmin } from '@/proxy';

function deleteResource(languageId: string) {
  return getSMPBackendAPIAdmin().resourcesControllerDeleteV1(languageId);
}

export function useDeleteResource() {
  return useMutation({ mutationFn: deleteResource });
}
